import './SearchBar.scss'

import {Fragment, PureComponent} from 'react'
import PropTypes from 'prop-types'
import api from "../../../api.js"
import {connect} from 'react-redux'
import conf from '../../conf.js'
import Tooltip from 'rc-tooltip'

import {
  Book,
  List,
  Search,
  User
} from 'react-feather'
import sitemap from '../../../shared/media/svg/sitemap.svg'

import {isAdmin} from '../../../shared/services/userService.js'
import SearchInput from './components/SearchInput/SearchInput.jsx'
import FilterRequirements from '../../../shared/components/SearchBar/components/FilterRequirements/FilterRequirements.jsx'
import FilterUniverse from './components/FilterUniverse/FilterUniverse.jsx'
import Results from "./components/Results/Results.jsx"
import ResultsOffers from "../../../shared/components/FilterBar/components/Results/ResultsOffers.jsx"
import SkillsTreeModal from '../../../shared/components/Modals/SkillsTreeModal/SkillsTreeModal.jsx'

import CardRow from "../../../shared/components/Styled/Card/CardRow.jsx"
import CardCol from "../../../shared/components/Styled/Card/CardCol.jsx"

import { UNIVERSE_FILTER_KEY } from '../../../shared/constants/filters.js'

class SearchBar extends PureComponent {
  static propTypes = {
    canToggleView: PropTypes.bool,
    className: PropTypes.string,
    conf: PropTypes.object.isRequired,
    currentUser: PropTypes.object,
    filters: PropTypes.object.isRequired,
    isAdmin: PropTypes.bool,
    orderControl: PropTypes.node,
    placeholder: PropTypes.string,
    showKeywordsSearch: PropTypes.bool,
    showUniverseFilter: PropTypes.bool,
    skillsTreePosition: PropTypes.oneOf(['start', 'end']),
    topologies: PropTypes.array,
    target: PropTypes.string.isRequired,
  }

  static defaultProps = {
    canToggleView: false,
    className: '',
    isAdmin: false,
    orderControl: null,
    placeholder: 'Rechercher une compétence ...',
    showKeywordsSearch: true,
    showUniverseFilter: true,
    skillsTreePosition: 'start',
    topologies: [],
  }

  constructor(props) {
    super(props)
    this.state = {
      limit: parseInt(props?.searchQuery.limit ?? conf.search.limits.cards, 10),
      keywords: props?.searchQuery.keywords?.length ? props.searchQuery.keywords : [],
      universes: [],
      skillsModal: false,
      requirementsSelected: undefined,
    }
  }

  componentDidMount() {
    this.fetchUniverses()
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (JSON.stringify(this.props?.searchQuery.keywords?.length ? this.props.searchQuery.keywords : []) !== JSON.stringify(prevProps?.searchQuery.keywords?.length ? prevProps.searchQuery.keywords : [])) {
      this.setState({
        keywords: this.props?.searchQuery.keywords?.length ? this.props.searchQuery.keywords : [],
      })
    }
    if ((this.props?.searchQuery.limit ?? conf.search.limits.cards) !== (prevProps?.searchQuery.limit ?? conf.search.limits.cards)) {
      this.setState({
        limit: parseInt(this.props?.searchQuery.limit ?? conf.search.limits.cards, 10),
      })
    }
  }

  fetchUniverses = async () => {
    await api.universes.getAll()
      .then((response)=> {
        if(response.data) {
          this.setState({universes: response.data})
        }
      })
      .catch((error) => {
        console.error({error})
      })
  }

  onSelectUniverseChange = (value) => {
    const searchData = {}
    searchData[`${UNIVERSE_FILTER_KEY}`] = value

    this.props.onChange(searchData)
  }

  getSearchInputPlaceholder = () => {
    const {requirementsSelected} = this.state
    const {target} = this.props

    if(!requirementsSelected) {
      return target === "purchasers" ? `Rechercher une fonction` : `Rechercher une compétence`
    }

    if(requirementsSelected === 1) {
      return `Rechercher un ID`
    }

    if(requirementsSelected === 2) {
      return `Rechercher un Nom / Prénom`
    }

    if(requirementsSelected === 3) {
      return `Rechercher un Email`
    }

    if(requirementsSelected === 4) {
      return `Rechercher un Téléphone`
    }

    if(requirementsSelected === 5) {
      return `Rechercher un Commentaire`
    }

    return `Rechercher ...`
  }

  onChangeRequirements = (value) => {
    const {searchQuery, topologies} = this.props
    const data = searchQuery

    topologies.map((topology) => {
      if (!topology.name) {
        return undefined
      }
      if (data[topology.name]) {
        delete data[topology.name]
      }
      return true
    })

    if (!value) {
      Object.assign(data, {
        'active': 1,
        'cdi': 0,
        'complete': 1
      })
    }

    this.props.onChange({requirements: value})
    this.setState({requirementsSelected: value})
  }

  toggleSkillsModal = () => {
    this.setState((prevState) => ({
      skillsModal: !prevState.skillsModal
    }))
  }

  submitKeywords = () => {
    this.props.onChange({
      keywords: this.state.keywords,
    })
  }

  onKeywordsChange = (newVal) => {
    this.setState({keywords: newVal})
    this.props.onChange({keywords: newVal})
  }

  onToggleView = () => {
    const newLimit = (this.state.limit === conf.search.limits.cards) ? conf.search.limits.list : conf.search.limits.cards
    this.setState({limit: newLimit})
    this.props.onChange({limit: newLimit})
  }

  /*
  onFiltersChange = (value) => {
    const keys = Object.keys(value);
    for (let i = 0; i < keys.length; i++) {
      for (let j = 0; j < this.props.filters.orders.length; j++) {
        if (keys[i] !== this.props.filters.orders[j].name) {
          value[this.props.filters.orders[j].name] = null;
        }
      }
    }

    this.props.onChange(value);
  };
  */

  render() {
    const {
      onChangeRequirements,
      toggleSkillsModal,
      getSearchInputPlaceholder
    } = this

    const {
      conf,
      resultsCount = 0,
      activeCount = 0,
      target,
      isAdmin,
      canToggleView,
      filters,
      currentUser,
      className,
      orderControl,
      placeholder,
      showKeywordsSearch,
      showUniverseFilter,
      skillsTreePosition
    } = this.props

    const {universes} = this.state

    const selectedUniverse = this.props?.searchQuery.universe
      ?? (this.props.currentUniverseId ? this.props.currentUniverseId : this.props.userMainUniverseId)

    const availableUniversesOptions = universes.map((universe) => {
      return {value: universe.id, text: universe.name}
    })

    const isFreelanceTarget = target === conf.search.targets.freelances
    const isOffersTarget = target === conf.search.targets.offers

    const hasFilterToShow = Object.keys(filters).length !== 0 && (
      canToggleView ||
      (isAdmin && filters.adminOnlyRequirements) ||
      (null !== currentUser && !filters.adminOnlyRequirements)
    )

    return (
      <Fragment>
        {/* Mobile */}
        <CardRow
          id="search"
          className={`search-bar-wrapper search-bar-wrapper-mobile ${className}`}
          align="center"
        >
          <CardCol style={{width: '100%'}}>
            {showKeywordsSearch && (
              <CardRow align={'center'} style={{width: '100%', borderBottomWidth: '1px'}} justify={'space-between'}>
                <CardCol className={"search-bar"} flex={6}>
                  {/*search input*/}
                  <CardRow align="center">
                    <CardCol flex={1}>
                      <SearchInput
                        className="input-search"
                        value={this.state.keywords}
                        onChange={this.onKeywordsChange}
                        placeholder={placeholder}
                        onEnter={this.submitKeywords}
                      />
                    </CardCol>
                    <CardCol>
                      <button
                        className="btn btn-lg btn-search"
                        type="button"
                        onClick={this.submitKeywords}>
                        <Search/>
                      </button>
                    </CardCol>
                  </CardRow>
                </CardCol>

                <CardCol flex={4} style={{borderLeftWidth: '1px'}}>
                  {/*requirements*/}
                  {hasFilterToShow && (
                    <CardRow justify="space-evenly">
                      {canToggleView && isAdmin
                        ? <CardCol className="icon-col">
                          <Tooltip placement={"bottom"} overlay={'Changer la vue'}>
                            {this.state.limit === conf.search.limits.cards ?
                              <User size={30} onClick={this.onToggleView} className="toogle-view"/> :
                              <List size={30} onClick={this.onToggleView} className="toogle-view"/>
                            }
                          </Tooltip>
                        </CardCol>
                        : null
                      }

                      {isOffersTarget &&
                        <CardCol className={'search-filter-requirements'}>
                          <FilterRequirements
                            value={this.props?.searchQuery.requirements ?? ''}
                            choices={this.props?.filters.requirementChoices?.length ? this.props.filters.requirementChoices : []}
                            onChange={onChangeRequirements}
                          /></CardCol>
                      }

                      {isFreelanceTarget && (
                        (isAdmin && filters.adminOnlyRequirements)
                        || (null !== currentUser && !filters.adminOnlyRequirements)
                      )
                        ? <CardCol className={'icon-col search-filter-requirements'}>
                          <Book size={24}/>
                        </CardCol>
                        : null
                      }
                    </CardRow>
                  )}
                </CardCol>
              </CardRow>
            )}
            <CardRow
              gap={'0.5rem'}
              align={'center'}
              justify={'space-evenly'}
              style={{borderBottomWidth: '1px'}}>
              {isAdmin && showUniverseFilter &&
                <CardCol
                  p={'0.3rem'}
                  style={{
                    borderRightWidth: '1px',
                    padding: '0.3rem',
                  }}>
                  <FilterUniverse
                    value={selectedUniverse}
                    choices={availableUniversesOptions}
                    onChange={this.onSelectUniverseChange}
                  />
                </CardCol>
              }

              <CardCol flex={1} style={{
                minHeight: '2.5rem',
              }}>
                {isFreelanceTarget && <Results nbResults={resultsCount} nbActive={activeCount}/>}
                {isOffersTarget && (
                  <ResultsOffers nb={resultsCount} conf={conf}/>
                )}
              </CardCol>
            </CardRow>

            {(skillsTreePosition === 'end' || orderControl) && (
              <CardRow align={'center'} justify={'center'} gap={'0.5rem'} style={{borderBottomWidth: '1px'}}>
                {skillsTreePosition === 'end' && (
                  <CardCol className="icon-col search-filter-skills">
                    <div className="icon-wrapper">
                      <Tooltip placement={"bottom"} overlay={'Arbre de compétences'}>
                        <img style={{width: "24px"}} src={sitemap} alt="Arbre de compétences" onClick={toggleSkillsModal} />
                      </Tooltip>
                    </div>
                  </CardCol>
                )}

                {orderControl && (
                  <CardCol className="bordered-left search-order-control">
                    {orderControl}
                  </CardCol>
                )}
              </CardRow>
            )}
          </CardCol>
        </CardRow>

        {/* Desktop */}
        <CardRow
          id="search"
          className={`search-bar-wrapper search-bar-wrapper-desktop ${className}`}
          align="center"
          p={"0 20px 0 0"}
        >
          {showKeywordsSearch && (
            <CardCol className={"search-bar bordered-right"} flex={'auto'}>
              <CardRow align="center">
                <CardCol flex={1}>
                  <SearchInput
                    className="input-search"
                    value={this.state.keywords}
                    onChange={this.onKeywordsChange}
                    placeholder={getSearchInputPlaceholder()}
                    onEnter={this.submitKeywords}
                  />
                </CardCol>
                <CardCol>
                  <button
                    className="btn btn-lg btn-search"
                    type="button"
                    onClick={this.submitKeywords}>
                    <Search/>
                  </button>
                </CardCol>
              </CardRow>
            </CardCol>
          )}

          {skillsTreePosition === 'start' && (
            <CardCol className={`icon-col search-filter-skills bordered-right`}>
              <div className="icon-wrapper">
                <Tooltip placement={"bottom"} overlay={'Arbre de compétences'}>
                  <img style={{width: "24px"}} src={sitemap} alt="Arbre de compétences" onClick={toggleSkillsModal} />
                </Tooltip>
              </div>
            </CardCol>
          )}

          {showKeywordsSearch && (
            <CardCol className={'bordered-right'}>
              <FilterRequirements
                value={this.props?.searchQuery.requirements ?? ''}
                choices={this.props?.filters.requirementChoices?.length ? this.props.filters.requirementChoices : []}
                onChange={this.onChangeRequirements}
              />
            </CardCol>
          )}

          {isAdmin && showUniverseFilter && (
            <CardCol className={'bordered-right'}>
              <FilterUniverse
                value={selectedUniverse}
                choices={availableUniversesOptions}
                onChange={this.onSelectUniverseChange}
              />
            </CardCol>
          )}

          {isFreelanceTarget && <CardCol><Results nbResults={resultsCount} nbActive={activeCount}/></CardCol>}
          {isOffersTarget && (
            <CardCol>
              <ResultsOffers nb={resultsCount} conf={conf}/>
            </CardCol>
          )}

          {canToggleView && isAdmin && (
            <Fragment>
              <CardCol className={'icon-col'}>
              Afficher par :
                <Tooltip placement={"bottom"} overlay={'Changer la vue'}>
                  {this.state.limit === conf.search.limits.cards ?
                    <User size={30} onClick={this.onToggleView}  className="toogle-view"/> :
                    <List size={30} onClick={this.onToggleView}  className="toogle-view"/>
                  }
                </Tooltip>
              </CardCol>
            </Fragment>
          )}

          {skillsTreePosition === 'end' && <CardCol flex={1} />}

          {skillsTreePosition === 'end' && (
            <CardCol className="icon-col search-filter-skills bordered-left">
              <div className="icon-wrapper">
                <Tooltip placement={"bottom"} overlay={'Arbre de compétences'}>
                  <img style={{width: "24px"}} src={sitemap} alt="Arbre de compétences" onClick={toggleSkillsModal} />
                </Tooltip>
              </div>
            </CardCol>
          )}

          {orderControl && (
            <CardCol className="bordered-left search-order-control">
              {orderControl}
            </CardCol>
          )}
        </CardRow>

        <SkillsTreeModal
          modal={this.state.skillsModal}
          toggle={toggleSkillsModal}
        />
      </Fragment>
    )}
}

export default connect(
  state => ({
    currentUser: state.currentUser.user,
    userMainUniverseId: state.currentUser?.user.mainUniverse ?? null,
    currentUniverseId: state.universe?.currentUniverse.id ?? null,
    isAdmin: isAdmin(state.currentUser.user, state.universe.currentUniverse)
  })
)(SearchBar)
